export default __webpack_public_path__ + "static/media/wDress_1_p3.2bc99b80.jpeg";